import { createReducer, on } from '@ngrx/store';

import * as UserActions from './user.actions';
import { initialState } from './user.state';

export const userReducer = createReducer(
  initialState,

  // Login Actions
  on(UserActions.login, state => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UserActions.loginSuccess, (state, { response }) => ({
    ...state,
    auth: {
      isAuthenticated: true,
      loginData: response.data,
    },
    loading: false,
    error: null,
    lastUpdated: Date.now(),
  })),

  on(UserActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    lastUpdated: Date.now(),
  })),

  // User Details Actions
  on(UserActions.loadUserDetails, state => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UserActions.loadUserDetailsSuccess, (state, { user }) => ({
    ...state,
    currentUser: user.data || null,
    loading: false,
    error: null,
    lastUpdated: Date.now(),
  })),

  on(UserActions.loadUserDetailsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    lastUpdated: Date.now(),
  })),

  // Logout Actions
  on(UserActions.logout, state => ({
    ...state,
    loading: true,
  })),

  on(UserActions.logoutSuccess, () => ({
    ...initialState,
    loading: false,
  })),

  // Loading Actions
  on(UserActions.setLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),

  // Select CNPJ Actions
  on(UserActions.selectCnpj, (state, { document }) => ({
    ...state,
    currentUser: state.currentUser
      ? {
          ...state.currentUser,
          document,
        }
      : null,
    auth: {
      ...state.auth,
      loginData: state.auth.loginData
        ? {
            ...state.auth.loginData,
            document,
          }
        : state.auth.loginData,
    },
    lastUpdated: Date.now(),
  })),

  // Select Contract (Fixa) Actions
  on(UserActions.selectContract, (state, { contract }) => ({
    ...state,
    selectedContract: contract,
    lastUpdated: Date.now(),
  })),

  on(UserActions.selectContractSuccess, (state, { contractDetails }) => ({
    ...state,
    selectedContractDetails: contractDetails,
    lastUpdated: Date.now(),
  })),

  // LoginData update (parcial) – usado para FIXA quando o uuid vem só após o selectContract
  on(UserActions.updateLoginData, (state, { loginData }) => ({
    ...state,
    auth: {
      ...state.auth,
      loginData: state.auth.loginData
        ? ({
            ...state.auth.loginData,
            ...loginData,
          } as typeof state.auth.loginData)
        : state.auth.loginData,
    },
    lastUpdated: Date.now(),
  }))
);
